import { render, staticRenderFns } from "./krasTargetProcessDetail.vue?vue&type=template&id=21fe22fe"
import script from "./krasTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./krasTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fe22fe')) {
      api.createRecord('21fe22fe', component.options)
    } else {
      api.reload('21fe22fe', component.options)
    }
    module.hot.accept("./krasTargetProcessDetail.vue?vue&type=template&id=21fe22fe", function () {
      api.rerender('21fe22fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasTargetProcessDetail.vue"
export default component.exports